import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";

export interface UseNodeNodeManagerInfoBarPillsNavHookProps {
  backToSourcesList: () => void;
  updateNodeManagerActiveView: (view: string) => void;
}

export const useNodeManagerInfoBarPillsNavHook =
  (): UseNodeNodeManagerInfoBarPillsNavHookProps => {
    const nodeManager = getNodeManager();

    return {
      backToSourcesList:
        nodeManager.backToSourcesListSetNavPillToTreeStructureDefault,
      updateNodeManagerActiveView:
        nodeManager.switchNodeManagerActiveViewOnClick,
    };
  };
